/*
This script continously loads post as the user scrolls the page. It uses the IntersectionObserver API to detect when the last post is in view. When the last post is in view, it fetches the next page and appends the posts to the page. It then checks if there is a next page and if there is, it continues to observe the last post. If there is no next page, it disconnects the observer. 

Importantly, for this script to work, it requires that each card have the `post` class and that the card container have the `gh-postfeed` class
*/

let link = document.querySelector('link[rel="next"]')?.getAttribute('href');

// Fetch and parse next page
async function getNextPage(url) {
    try {
        const res = await fetch(url);
        
        if (!res.ok) {
            throw new Error('Failed to fetch page')
        }
        
        const nextPageHtml = await res.text();
        const parser = new DOMParser();
        const parsed = parser.parseFromString(nextPageHtml, 'text/html');
        const posts = parsed.querySelectorAll('.post');
        const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute('href');
        
        return {posts, nextLink}

    } catch (error) {
        throw new Error(error)
    }
}

export default function infiniteScroll(onAppend) {

    const feed = document.querySelector('.gh-postfeed');

    if (!link || !feed || !document.querySelector('.post:last-of-type')) { return; }

    const options = {
        // When the last card is within a 150px of the viewport, fetch the next page. This provides a smoother transition between pages 
       rootMargin: '150px',
    }

    // A card stays observed until we explicitly drop it, and a fetch takes time
    // to come back. Without the guard below, scrolling back over an already
    // used card — or crossing the threshold again while a request is still in
    // flight — starts a second fetch for the same link and appends the same
    // posts twice. The trigger is dropped only once its page has landed, so a
    // failed request leaves something behind that can still retry.
    let isLoading = false;

    const callback = (entries, observer) => {
        entries.forEach(entry => {

            if (!entry.isIntersecting || isLoading || !link) { return; }

            isLoading = true;

            getNextPage(link).then(({posts, nextLink}) => {
                // Only now has this card done its job; the appended page brings
                // its own trigger along.
                observer.unobserve(entry.target);

                posts.forEach(post => {
                    feed.append(post)
                    if (typeof onAppend === 'function') { onAppend(post) }
                })

                if (nextLink) {
                    link = nextLink;
                    const last = document.querySelector('.post:last-of-type');
                    if (last) { observer.observe(last) }
                } else {
                    observer.disconnect()
                }

                isLoading = false;
            }).catch(error => {
                // The trigger is deliberately still observed, so scrolling away
                // and back retries. Re-observing it here instead would re-fire
                // immediately while it is on screen and hammer a failing feed.
                console.error(error)
                isLoading = false;
            })
        })
    }

    let observer = new IntersectionObserver(callback, options);

    observer.observe(document.querySelector('.post:last-of-type'))

}